import type { NoteOctave, Octave } from '@tunasong/music-lib'
import { NoteLib } from '@tunasong/music-lib'

export const midiToNote = (midi: number): NoteOctave => {
  const index = midi % 12
  const octave = (Math.floor(midi / 12) - 1) as Octave

  const note = NoteLib.getNoteByIndex(index)

  return `${note}${octave}`
}
